<template>
    <div v-show="show" :class="wrapperCssClass">
        <input
            type="hidden"
            :name="name"
            :id="id"
            :value="value"
            @input="update($event.target.value)"
        >
    </div>
</template>
<script>
    import TextInput from '../../../mixins/Form/TextInput.vue';
    export default {
        mixins: [TextInput]
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/src/components/Form/Inputs/HiddenInput.vue